var _defs, _path, _line;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketCompactW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Strokes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-dasharray:32 12;}.cls-1,.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:10px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.30285,73.34137v33.95005c0,3.35182,1.70464,6.50749,4.57688,8.23518,11.68823,7.0306,19.50312,19.84026,19.50312,34.4734s-7.81489,27.4428-19.50312,34.4734c-2.87225,1.72769-4.57688,4.88336-4.57688,8.23518v33.95005c0,2.94843,2.39017,5.3386,5.3386,5.3386h198.71711c2.94843,0,5.3386-2.39017,5.3386-5.3386v-33.95005c0-3.35182-1.70464-6.50749-4.57688-8.23518-11.68823-7.0306-19.50312-19.84026-19.50312-34.4734s7.81489-27.4428,19.50312-34.4734c2.87225-1.72769,4.57688-4.88336,4.57688-8.23518v-33.95005c0-2.94843-2.39017-5.3386-5.3386-5.3386H50.64144c-2.94843,0-5.3386,2.39017-5.3386,5.3386Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 198.59574,
    y1: 68.00277,
    x2: 198.59574,
    y2: 231.99723
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketCompactW);
export default __webpack_public_path__ + "static/media/ticket-compact-w.6a1562a52198697cf2425d16c56a1b06.svg";
export { ForwardRef as ReactComponent };